class CustomStyle {
  constructor(key, customStyle) {
    this.key = key;
    this.customStyle = customStyle;
  }
  getKey() {
    return this.key;
  }
  toCustomStyle() {
    return this.customStyle;
  }
  overrideWith(customStyle) {
    if (customStyle.key !== "empty" && this.key !== customStyle.key) {
      throw new Error(`Different keys, ${this.key} doesn't equal to ${customStyle.key}`);
    }
    return new CustomStyle(this.key, { ...this.customStyle, ...customStyle.customStyle });
  }
}
export {
  CustomStyle as default
};
//# sourceMappingURL=custom-style.js.map
